import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { HeaderBannerDetailApi } from '../header-banner-detail/api/header-banner-detail-api';
import { HeaderBannerListApi } from '../header-banner-list/api/header-banner-list-api';

export class HeaderBannerApi {
    constructor(protected baseUrl: string) {
        this.HeaderBannerList = new HeaderBannerListApi(this.baseUrl);
        this.HeaderBannerDetail = new HeaderBannerDetailApi(this.baseUrl);
    }

    public HeaderBannerList: HeaderBannerListApi;
    public HeaderBannerDetail: HeaderBannerDetailApi;

    public deleteHeaderBanner(id: number): Promise<ApiResult<void>> {
        return safeRequest(() => request.delete(`${this.baseUrl}/header-banners/${id}`), noop);
    }
}
